import CashierServiceModel from "../CashierServiceModel";
import InvoiceItemCollection from "@/collections/cashier/InvoiceItemCollection";
import CustomerModel from "@/models/crm/CustomerModel";

export default class InvoiceModel extends CashierServiceModel {
  modelName() {
    return 'invoices';
  }
  defaults() {
    return {
      id: null,
      stripe_id: null,
      user_id: null,
      user: null,
      customer_id: null,
      customer: null,
      auto_advance: null,
      collection_method: null,
      custom_fields: null,
      description: null,
      due_date: null,
      metadata: null,
      statement_descriptor: null,
      credit: null,
      updated_at: null,
      deleted_at: null,
      invoice_items: [],
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      stripe_id: (val) => (this.nullStringMutator(val)),
      user_id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      auto_advance: Boolean,
      collection_method: (val) => (this.nullStringMutator(val)),
      custom_fields: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      due_date: (val) => (this.nullStringMutator(val)),
      metadata: (val) => (this.nullStringMutator(val)),
      statement_descriptor: (val) => (this.nullStringMutator(val)),
      credit: Boolean,
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }
  validation() {
    return {}
  }
  getInvoiceItems() {
    return this.getRelatedCollection(new InvoiceItemCollection(), 'invoice_items');
  }
  getCustomer() {
    return this.getRelatedModel(CustomerModel, 'customer');
  }
}
